import { render } from "./Traders.vue?vue&type=template&id=1c397840&ts=true"
import script from "./Traders.vue?vue&type=script&lang=ts"
export * from "./Traders.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__